import env from '@/core/utils/env'

export const webServerAddr = `/h5/fireworks`

export const actId = (() => {
  let nm = 'IFO2020121401482500'
  if (env === 'testing') {
    nm = `IFO2020121401477400`
  } else if (env === 'pre') {
    nm = `IFO2020121401478700`
  }

  return nm
})()

export const inviteId = (() => {
  let nm = 'IFO2020121701281200'
  if (env === 'testing') {
    nm = `IFO2020121701274200`
  } else if (env === 'pre') {
    nm = `IFO2020121701277800`
  }

  return nm
})()
